import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNonogramTopTimes } from '@games/api';
import { HelmetTitle } from '@games/ui';
import messages from 'intl/messages';
import Loader from './Loader';
import TopTimeList from './TopTimeList';

const TopTimePage: React.FC = () => {
  const [{ loading, error, data }] = useNonogramTopTimes();
  const { formatMessage } = useIntl();

  if (error) {
    return (
      <FormattedMessage {...messages.ajaxError} />
    );
  }
  if (loading || !data) {
    return (
      <div className='text-center'>
        <HelmetTitle message={formatMessage(messages.topTimes)} />
        <FormattedMessage {...messages.loading} />
        <Loader />
      </div>
    );
  }
  return (
    <div className='container mx-auto'>
      <HelmetTitle message={formatMessage(messages.topTimes)} />
      <div className='flex flex-wrap justify-center gap-8'>
        {data.map(times => (
          <div className='w-full lg:w-1/4 md:w-1/2' key={times.size}>
            <TopTimeList
              size={times.size}
              times={times.times}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopTimePage;
